/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Payout_On_HoldInputs */

const en_rental_payout_on_hold = /** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout On Hold`)
};

const es_rental_payout_on_hold = /** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago Retenido`)
};

const fr_rental_payout_on_hold = /** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement en attente`)
};

const de_rental_payout_on_hold = /** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung zurückgehalten`)
};

const id_rental_payout_on_hold = /** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran Ditahan`)
};

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const ja_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const zh_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const ar_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const it_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const ru_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const pt_rental_payout_on_hold = en_rental_payout_on_hold;

/** @type {(inputs: Rental_Payout_On_HoldInputs) => LocalizedString} */
const ko_rental_payout_on_hold = en_rental_payout_on_hold;

/**
* | output |
* | --- |
* | "Payout On Hold" |
*
* @param {Rental_Payout_On_HoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_payout_on_hold = /** @type {((inputs?: Rental_Payout_On_HoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Payout_On_HoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_payout_on_hold(inputs)
	if (locale === "es") return es_rental_payout_on_hold(inputs)
	if (locale === "fr") return fr_rental_payout_on_hold(inputs)
	if (locale === "de") return de_rental_payout_on_hold(inputs)
	if (locale === "ja") return ja_rental_payout_on_hold(inputs)
	if (locale === "zh") return zh_rental_payout_on_hold(inputs)
	if (locale === "ar") return ar_rental_payout_on_hold(inputs)
	if (locale === "id") return id_rental_payout_on_hold(inputs)
	if (locale === "it") return it_rental_payout_on_hold(inputs)
	if (locale === "ru") return ru_rental_payout_on_hold(inputs)
	if (locale === "pt") return pt_rental_payout_on_hold(inputs)
	return ko_rental_payout_on_hold(inputs)
});